/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    object, shape, string,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import LinkOrATag from '../../GraphqlCommonComponents/LinkOrATag/LinkOrATag';

const styles = (theme) => ({
    block: {
        border: `1px solid ${theme.palette.grey7}`,
        margin: '10px 0',
        alignItems: 'center',
        '& img': {
            width: '100%',
            display: 'block',
        },
        [theme.breakpoints.down(600)]: {
            maxWidth: '80%',
            margin: '10px auto',
            '& img': {
                maxHeight: 150,
            },
        },
    },
    description: {
        textAlign: 'center',
        '& h3': {
            maxWidth: 230,
            margin: 'auto',
            width: '100%',
            display: 'block',
        },
        '& a': {
            textDecoration: 'none',
            color: theme.palette.common?.black,
            border: `1px solid ${theme.palette.common?.black}`,
            padding: '13px 10px',
            fontSize: 20,
            fontWeight: 'bold',
            textTransform: 'uppercase',
        },
        '& p': {
            fontSize: 22,
            margin: 0,
        },
        [theme.breakpoints.down(768)]: {
            '& h3, p': {
                fontSize: 17,
            },
        },
        [theme.breakpoints.down(600)]: {
            '& h3': {
                fontSize: 15,
            },
            '& p': {
                margin: 0,
                fontWeight: 'normal',
                fontSize: 14,
            },
            '& a': {
                fontSize: 14,
                padding: '5px 10px',
            },
            margin: '10px auto 20px',
            maxWidth: 230,
        },
    },
    mobileBlock: {
        [theme.breakpoints.down(600)]: {
            flexDirection: 'column-reverse',
        },
    },
    mobileGrid: {
        [theme.breakpoints.down(600)]: {
            flexBasis: 'auto',
        },
    },
    CTAButtonStyle: {
        marginTop: 20,
        [theme.breakpoints.down(600)]: {
            marginTop: 10,
        },
    },
});

const ListBlock = ({
    data, classes, brand,
}) => {
    if (!data) return null;
    const {
        image: { url, description }, main_copy, sub_copy, button_link: { title, href }, image_placement,
    } = data;

    let link = href || '';

    if (href?.substring(0, 4) === '/blog' || href?.includes?.('/articles')) {
        link = `https://www.${brand?.domain}.com${href}`;
    }
    if (image_placement === 'right') {
        return (
            <Grid
                container
                className={`${classes.block} ${classes.mobileBlock}`}
            >
                <Grid className={`${classes.mobileGrid}`} item xs={12} sm={6}>
                    <div className={classes.description}>
                        {main_copy && <h3>{main_copy}</h3>}
                        {sub_copy && <p>{sub_copy}</p>}
                        {title
                            && (
                                <div className={classes.CTAButtonStyle}>
                                    <LinkOrATag href={link} ariaLabel={`Click to ${title}`}>
                                        {title}
                                    </LinkOrATag>
                                </div>
                            )}

                    </div>
                </Grid>
                <Grid item className={`${classes.mobileGrid}`} xs={12} sm={6}>
                    <img src={url} alt={description || 'Memorial Images'} />
                </Grid>
            </Grid>
        );
    }
    return (
        <Grid container className={classes.block}>
            <Grid item xs={12} sm={6}><img src={url} alt={description || 'Memorial Tiles'} /></Grid>
            <Grid item xs={12} sm={6}>
                <div className={classes.description}>
                    {main_copy && <h3>{main_copy}</h3>}
                    {sub_copy && <p>{sub_copy}</p>}
                    <div className={classes.CTAButtonStyle}>
                        <LinkOrATag href={link} ariaLabel={`Click to ${title}`}>
                            {title}
                        </LinkOrATag>
                    </div>
                </div>
            </Grid>
        </Grid>
    );
};

ListBlock.propTypes = {
    classes: object.isRequired,
    brand: shape({
        'domain-name': string,
    }).isRequired,
    data: shape({
        image: shape({
            url: string.isRequired,
            filename: string.isRequired,
        }),
        main_copy: string.isRequired,
        sub_copy: string.isRequired,
        button_link: shape({
            title: string.isRequired,
            href: string.isRequired,
        }),
    }).isRequired,

};
export default withStyles(styles)(ListBlock);
